module.exports = __webpack_public_path__ + "static/media/holiday-hours.89a8eedb.jpg";